module.exports = __webpack_public_path__ + "static/media/add.8cd796a3.svg";